import { render } from "./CFANavOnly.vue?vue&type=template&id=20d92ba4&scoped=true"
import script from "./CFANavOnly.vue?vue&type=script&lang=js"
export * from "./CFANavOnly.vue?vue&type=script&lang=js"

import "./CFANavOnly.vue?vue&type=style&index=0&id=20d92ba4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d92ba4"]])

export default __exports__